import { urlBaseAccreditation } from "../../config";
import axiosInstance from "../../../services/config/axiosinstance";
import FaceCollectorConfigModel from './../../../models/FaceCollectorConfigModel';

export default async function saveFaceCollectorConfig(faceCollectorConfig = FaceCollectorConfigModel()) {
  try {
    const _config = {
      method: 'POST',
      url: `${urlBaseAccreditation}/faceCollectorConfig/saveFaceCollectorConfig`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        eventId: faceCollectorConfig.eventId,
        system: faceCollectorConfig.system,
        backgroundImage: faceCollectorConfig.backgroundImage,
        backgroundColor: faceCollectorConfig.backgroundColor,
        textColor: faceCollectorConfig.textColor,
        buttonBackgroundColor: faceCollectorConfig.buttonBackgroundColor,
        buttonTextColor: faceCollectorConfig.buttonTextColor,
        miceContractId: faceCollectorConfig.miceContractId,
        photoAttributeId: faceCollectorConfig.photoAttributeId,
        detectionType: faceCollectorConfig.detectionType,
      }
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return null;
  } catch (error) {
    console.log('Error saveFaceCollectorConfig', error);
    throw error;
  }
}
